// extracted by mini-css-extract-plugin
module.exports = {"imgix":"b_"};